
import { erpApi } from '@/shared/axios/erp-api';
import { urlBackend } from '@/shared/constants';

import { MaterialTransferido } from '@/shared/interfaces';
const { post} = erpApi();


interface CargarExcelResponse {
  productos: MaterialTransferido[];
  errores: string[];
  total_validos?: number;
  total_errores?: number;
}


export const cargarExcelSolicitudEgreso = async (data: { url: string; ubicacion: string }) => {
  const res = await post<CargarExcelResponse>(
    `${urlBackend}api/v1/solicitud-egreso/cargar-excel/`,
    data,
    true,
    true // typeJson: enviamos y recibimos JSON
  );
  return res;
};
